//@flow
import React, { Component } from 'react';
import { type TooltipProps } from '..';
import { Desktop, Default, LgDesktop } from '../../../components/Responsive';
import { ModelListTh } from '../../../components/ModelListStyles';
import Switch from '../../../components/Switch';
import { PROCESSING_VOLUME_TOOLTIP, TRANSACTION_FEES_TOOLTIP } from './reducer';
import { CustomInfoTooltip } from './ReferredPartnersIndexStyles';
import DefaultModelRowTr from '../../../modules/CrudTable/components/DefaultModelRowTr';

type Props = {
  orderBy: {
    processingVolume: number => void,
    transactionFee: number => void,
    numMerchants: number => void
  },
  orderState: {
    processingVolume: number,
    transactionFee: number,
    numMerchants: number
  },
  ...$Exact<TooltipProps>
};

export default class TableHeader extends Component<Props> {
  handleProcessingVolClick = (orderState: number) => {
    this.props.orderBy.processingVolume(orderState);
  };

  handleTransactionFeeClick = (orderState: number) => {
    this.props.orderBy.transactionFee(orderState);
  };

  handleNumMerchantsClick = (orderState: number) => {
    this.props.orderBy.numMerchants(orderState);
  };
  render() {
    return (
      <DefaultModelRowTr>
        <ModelListTh>Partner</ModelListTh>
        <LgDesktop>
          <ModelListTh>Date Created</ModelListTh>
        </LgDesktop>
        <Default>
          <ModelListTh right>
            <Switch
              text={'Merchants'}
              orderState={this.props.orderState.numMerchants}
              handleClick={orderState =>
                this.handleNumMerchantsClick(orderState)
              }
            />
          </ModelListTh>
        </Default>
        <ModelListTh right>
          <Desktop>
            <CustomInfoTooltip
              message={
                'The amounts below are estimates based on the exchange rate at the time of purchase. Click to view exact breakdowns / details'
              }
              activeTooltip={this.props.activeTooltip}
              showTooltip={this.props.showTooltip}
              tooltipName={PROCESSING_VOLUME_TOOLTIP}
              smallIcon
            />
          </Desktop>
          <Switch
            text={'Processing Vol.'}
            orderState={this.props.orderState.processingVolume}
            handleClick={orderState =>
              this.handleProcessingVolClick(orderState)
            }
          />
        </ModelListTh>
        <Desktop>
          <ModelListTh right>
            <Desktop>
              <CustomInfoTooltip
                message={
                  'The amounts below are estimates based on the exchange rate at the time of purchase. Click to view exact breakdowns / details'
                }
                activeTooltip={this.props.activeTooltip}
                showTooltip={this.props.showTooltip}
                tooltipName={TRANSACTION_FEES_TOOLTIP}
                smallIcon
              />
            </Desktop>
            <Switch
              text={'Trans. Fees'}
              orderState={this.props.orderState.transactionFee}
              handleClick={orderState =>
                this.handleTransactionFeeClick(orderState)
              }
            />
          </ModelListTh>
        </Desktop>
      </DefaultModelRowTr>
    );
  }
}
